import{m as a}from"./ninox-components-2ADN25D5.js";import t from"styled-components";var s=t.div`
    overflow: auto;
    overflow: overlay;
    scrollbar-gutter: auto;
    box-sizing: border-box;

    --webkit-scrollbar-width: ${({size:r})=>r==="auto"&&a.x_small||(r==="none"||!r)&&"0"||a.xxx_small};

    /** Safari */
    &::-webkit-scrollbar {
        display: ${({size:r})=>(r==="none"||!r)&&"none"};
        cursor: pointer;
        width: calc(var(--webkit-scrollbar-width) ${`+ 2 * ${a.tiny}`});
        height: calc(var(--webkit-scrollbar-width) ${`+ 2 * ${a.tiny}`});
        transition: all ease 500ms;
    }

    &::-webkit-scrollbar-track {
        border-radius: ${Number.MAX_SAFE_INTEGER}px;
        background-color: ${({theme:r,autoHide:o,showBackground:l})=>o||!l?"transparent":r.scrollbars.default.track};
    }

    &:hover::-webkit-scrollbar-track {
        background-color: ${({theme:r,showBackground:o})=>o&&r.scrollbars.hover.track};
    }

    &::-webkit-scrollbar-thumb {
        background-clip: padding-box;
        cursor: pointer;

        border-radius: ${Number.MAX_SAFE_INTEGER}px;
        border-style: solid;
        border-width: ${a.tiny};
        border-color: transparent;

        background-color: ${({theme:r,autoHide:o})=>o?"transparent":r.scrollbars.default.thumb};
    }

    &:hover::-webkit-scrollbar-thumb {
        background-color: ${({theme:r})=>r.scrollbars.hover.thumb};
    }

    &::-webkit-scrollbar-corner {
        display: none;
    }

    @supports (scrollbar-width: thin) {
        scrollbar-width: ${({size:r})=>r==="auto"&&r||(r==="none"||!r)&&"none"||"thin"};
        scrollbar-color: ${({theme:r,autoHide:o,showBackground:l})=>o?"transparent transparent":`${r.scrollbars.default.thumb} ${l?r.scrollbars.default.track:"transparent"}`};

        &:hover {
            scrollbar-color: ${({theme:r,showBackground:o})=>`${r.scrollbars.hover.thumb} ${o?r.scrollbars.hover.track:"transparent"}`};
        }
    }
`;s.defaultProps={autoHide:!1,size:"auto",showBackground:!1};export{s as a};
//# sourceMappingURL=ninox-components-ZXBPGGT2.js.map